<template>

  <div>
  <b-card style="position: relative" :title="$t('Filter Plans')">
    <b-row class="mt-2">
      <b-col sm="12" md="6">
        <b-form-group :label="$t('Owners')" label-for="vi-devices-id">
          <v-select multiple v-model="ownersFilterSelected" :close-on-select="false" :options="ownersFilterOptions" />
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group :label="$t('contracts')" label-for="vi-devices-id">
          <v-select multiple v-model="contractsFilterSelected" :close-on-select="false" :options="contractsFilterOptions" />
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>

  <!-- Table Container Card -->
  <b-card no-body class="mb-0">

    <div class="m-2">

      <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
        <label>{{ $t('Show') }}</label>
        <v-select v-model="perPage"
                  :options="[25,50,100,200,500]" :clearable="false" class="per-page-selector d-inline-block mx-50" />
        <label>{{ $t('entries') }}</label>
      </b-col>

      <b-col cols="12" md="6" xl="6" class="mt-2">
        <b-form-input v-model="searchText" class="d-inline-block mr-1" placeholder="Search..." style="width:60%" />
      </b-col>

      <!-- Table Top -->
      <b-table class="table table-sm mt-1"
               responsive small
               :busy="indicator"
               :per-page="perPage"
               :current-page="currentPage"
               :fields="fields.map((i) => ({ key: i.key, label: $t(i.label), sortable: i.sortable }))"
               :items="filteredItems">

        <template #table-busy>
          <div class="text-center p-5">
            <!-- Example: spinner with text -->
            <div class="loading_page">
            <orbit-spinner :animation-duration="1000" :size="30" :color="'#0e96b1'" />
          </div>
            <strong>{{$t('Loading data, please wait')}}</strong>
          </div>
        </template>

        <template #cell(id)="data"> {{ data.index + 1 }} </template>
        <template #cell(route)="data"> route </template>
        <template #cell(shift)="data"> <div class="text-center" style="border: 1px solid"> {{ get_shift(data.item) }}</div> </template>
        <template #cell(details)="data"> <div class="text-center" style="border: 1px solid"> {{ get_data(data.item) }}</div> </template>

        <template #cell(actions)="data">
          <b-dropdown class="actionIcon" boundary="viewport" size="sm" right variant="link">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>

            <b-dropdown-item :to="{ name: 'plans.washer.edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>

<!--            <b-dropdown-item @click="removeDrainagePlan(data.item.id)"-->
<!--                             v-if="$store.state.auth.userData.permissions.includes('plans.containerDump.destroy')">-->
<!--              <feather-icon icon="TrashIcon" />-->
<!--              <span class="align-middle ml-50">{{ $t('Delete')}}</span>-->
<!--            </b-dropdown-item>-->

          </b-dropdown>
        </template>

      </b-table>

      <!-- Pagination -->
      <b-pagination
          v-model="currentPage"
          :total-rows="list.length"
          :per-page="perPage"
          align="center"
          class="mt-3"
      />

    </div>

  </b-card>
  </div>
</template>


<script>
import { OrbitSpinner } from 'epic-spinners'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown, BDropdownItem, BFormGroup,
  BFormInput,
  BLink,
  BMedia, BPagination,
  BRow,
  BTable
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import AllPlansFilter from '@/views/modules/plans/filters/AllPlansFilter.vue'
import { computed, ref } from '@vue/composition-api'
import { useWasherPlanApi } from '@/views/modules/plans/washer-plan/composable/useWasherPlanApi'

export default {
  components: {
    BFormGroup,
    OrbitSpinner,
    BCard, BRow, BCol, BFormInput, BButton, BTable,
    BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,
    vSelect,
    AllPlansFilter
  },

  setup(props, { root }) {

    const indicator = ref(true)
    const currentPage = ref(1)
    const perPage = ref(25)

    const list = ref([])

    const { getPlans } = useWasherPlanApi()

    const fields = [
      {label: '#', key: 'id'},
      {label: 'name', key: 'name'},
      {label: 'device', key: 'device'},
      {label: 'owner', key: 'owner'},
      {label: 'contract', key: 'contract'},
      {label: 'camp', key: 'camp'},
      {label: 'shift', key: 'shift'},
      {label: 'containers count', key: 'details'},
      {label: '#', key: 'actions'},
    ]

    const params = ref({
      type: 'washer',
      sortBy: 'created_at, desc',
      noPagination: true
    })

    const ownersFilterOptions = ref([])
    const contractsFilterOptions = ref([])

    const ownersFilterSelected = ref([])
    const contractsFilterSelected = ref([])
    const searchText = ref('')

    const filteredItems = computed(() => {

      return list.value.filter(item => {

        const matchOwners =
            ownersFilterSelected.value.length === 0 ||
            ownersFilterSelected.value.includes(item.owner)

        const matchContracts =
            contractsFilterSelected.value.length === 0 ||
            contractsFilterSelected.value.includes(item.contract)

        const matchSearch =
            !searchText.value ||
            [item.name, item.owner, item.contract].some(field => field.includes(searchText.value))

        return matchOwners && matchContracts && matchSearch

      })
    })


    getPlans(params.value).then(r => {
      list.value = r.data.plans
      r.data.plans.map(p => {
        if(!ownersFilterOptions.value.includes(p.owner)) ownersFilterOptions.value.push(p.owner)
        if(!contractsFilterOptions.value.includes(p.contract)) contractsFilterOptions.value.push(p.contract)
      })

    }).catch(e => {}).finally(_ => indicator.value = false)


    const get_data = item => {
      let details = ''
      for (const i in item.data.schedules) {
        for (const z in item.data.schedules[i]) {
          if (z === 'week_schedule') {
            for (const x in item.data.schedules[i][z]) {
              details+= item.data.schedules[i][z][x]
            }
            details+= `(${item.data.schedules[i].containers.length})`
            details+= ' '
          }
        }
      }
      return details
    }

    const get_shift = item => `${item.camp_leave} --> ${item.camp_back}`;

    return {
      fields,
      list, filteredItems,
      get_data, get_shift,
      currentPage, perPage,
      indicator,
      ownersFilterOptions,
      contractsFilterOptions,
      ownersFilterSelected,
      contractsFilterSelected,
      searchText
    }

  }
}

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.per-page-selector {
  width: 90px;
}

</style>